<template>
  <div class="card--small-campaign">
    <router-link :to="'/campaigns/'+campaign.id" v-if="campaign.acf.merchant_logo" class="card--small-campaign__image">
      <img :src="campaign.acf.merchant_logo">
    </router-link>
    <div class="card--small-campaign__content">
      <span class="card--small-campaign__title"></span>
      <span class="card--small-campaign__category">
      {{ campaign.title }}
      </span>
      <span class="card--small-campaign__rate">
        Up to {{ campaign.acf.commission_rate }}
      </span>
      <router-link class="card--small-campaign__link" :to="'/campaigns/'+campaign.id">
        <translation en="View details" ch="查看详情"></translation>
      </router-link>
    </div>
  </div>
</template>

<script>

import Translation from "@/components/Translation.vue";

export default {
  name: 'SmallCampaignCard',
  components: {Translation},
  props : {
    campaign: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";


.card--small-campaign{
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
  box-sizing: border-box;
  &:last-of-type{
    border: 0;
  }
  a {
    @include bp(sm) {
      width: 100%;
    }
  }
  &__link{
    margin-top: 1.4rem;
    width: 9rem !important;
    border-radius: 5px;
    font-size: 1.2rem;
    background-color: #eee;
    padding: 3px 8px;
    text-align: center;
  }
  &__image{
    width: 100%;
    max-width:20rem;
    box-sizing: border-box;
    margin-bottom: 0.7rem;
    height: 9rem;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
    padding: 1rem 1rem;
    width: 100%;
    &:hover{
      cursor: pointer;
    }
    img{
      max-width: 9rem;
      width: 100%;
      @include bp(sm) {
        max-height: 5rem;
        max-width: 16rem;
        width: auto;
      }
    }
  }
  &__content{
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    justify-content:center;
    width:100%;
    span{
      width: 100%;
      text-align: center;
    }
  }
  &__title {
    font-size: 1rem;
    line-height: 1.3rem;
    font-weight: 600;
  }
  &__category {
    font-size: 1.3rem;
    line-height: 1.6rem;
    margin-top: 0.8rem;
    color: #666;
    margin-bottom: 0.15rem;
  }
  &__rate {
    margin-top: 0.8rem;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 600;
    @include bp(sm){
      font-size: 1.6rem;
    }
  }
}



</style>
